var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVacancies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.18632 1.30957C4.48376 1.30957 3.09961 2.69372 3.09961 4.39628C3.09961 6.06636 4.40578 7.41801 6.10834 7.4765C6.16033 7.47 6.21232 7.47 6.25131 7.4765C6.2643 7.4765 6.2708 7.4765 6.2838 7.4765C6.2903 7.4765 6.2903 7.4765 6.29679 7.4765C7.96037 7.41801 9.26654 6.06636 9.27304 4.39628C9.27304 2.69372 7.88889 1.30957 6.18632 1.30957Z",
    fill: "#FDC648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48809 9.2051C7.67505 7.99641 4.71833 7.99641 2.8923 9.2051C2.06701 9.75746 1.61212 10.5048 1.61212 11.3041C1.61212 12.1034 2.06701 12.8442 2.8858 13.39C3.79557 14.0009 4.99126 14.3063 6.18696 14.3063C7.38263 14.3063 8.57832 14.0009 9.48809 13.39C10.3069 12.8377 10.7618 12.0969 10.7618 11.2911C10.7553 10.4918 10.3069 9.75096 9.48809 9.2051Z",
    fill: "#FDC648"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.3276 4.77995C13.4316 6.04062 12.5348 7.14534 11.2936 7.2948C11.2871 7.2948 11.2871 7.2948 11.2806 7.2948H11.2611C11.2222 7.2948 11.1832 7.2948 11.1507 7.3078C10.5203 7.34029 9.94198 7.13884 9.50659 6.76844C10.1759 6.17059 10.5593 5.27382 10.4813 4.29907C10.4359 3.7727 10.2539 3.29182 9.98097 2.88243C10.2279 2.75896 10.5138 2.68098 10.8063 2.65499C12.0799 2.54451 13.2171 3.49327 13.3276 4.77995Z",
    fill: "#FDC648"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6279 10.7906C14.5759 11.421 14.173 11.9668 13.4972 12.3373C12.8473 12.6947 12.0285 12.8636 11.2162 12.8441C11.6841 12.4217 11.9571 11.8954 12.009 11.3365C12.074 10.5307 11.6906 9.75741 10.9238 9.14007C10.4884 8.79566 9.98156 8.52273 9.4292 8.32128C10.8653 7.90538 12.6719 8.18481 13.7831 9.08158C14.3809 9.56246 14.6864 10.1668 14.6279 10.7906Z",
    fill: "#FDC648"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancies);
export default __webpack_public_path__ + "static/media/vacancies.588ff9c8da13114257dd2be1763f2417.svg";
export { ForwardRef as ReactComponent };